module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "elections-3d",
    attrs: {
      "md-column": ""
    }
  }, [_c('md-toolbar', {
    staticClass: "md-whiteframe md-whiteframe-3dp",
    attrs: {
      "id": "navbar"
    }
  }, [_c('div', {
    staticClass: "md-logo"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://koumoul.com/"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('logo', {
    attrs: {
      "colors": ['#0091EA', '#80D8FF']
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "margin-left": "8px",
      "margin-top": "18px",
      "color": "white"
    }
  }, [_vm._v("Koumoul")])], 1)], 1)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Élection présidentielle du 7 mai 2017 - 2ème tour")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  })], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "top center",
      "md-duration": 12000
    }
  }, [_c('ul', {
    staticStyle: {
      "list-style-type": "none",
      "margin": "0"
    }
  }, [_c('li', [_vm._v("Utilisez le zoom pour passer entre les niveaux régions, départements et communes.")]), _vm._v(" "), _c('li', [_vm._v("Cliquez sur les éléments de la légende pour visualiser les scores d'un candidat.")]), _vm._v(" "), _c('li', [_vm._v("Cliquez sur une zone de la carte pour afficher les informations détaillées.")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("ok")])], 1), _vm._v(" "), (!_vm.mbglSupported) ? _c('p', {
    staticClass: "md-subheader"
  }, [_vm._v("Malheureusement votre navigateur ne supporte pas l'outil de cartographie utilisé par cette application.")]) : _vm._e(), _vm._v(" "), (_vm.error429) ? _c('p', {
    staticClass: "md-subheader"
  }, [_vm._v("Il semble que vous ayez atteint votre limite d'utilisation du service pour la journée. "), _c('a', {
    attrs: {
      "href": "https://koumoul.com/t/"
    }
  }, [_vm._v("Augmenter cette limite.")])]) : _vm._e(), _vm._v(" "), (_vm.mbglSupported && !_vm.error429) ? _c('md-layout', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "map-container"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('md-whiteframe', {
    staticClass: "legend"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('ul', [_c('li', [(!_vm.candidat || _vm.candidat === 'abstentions') ? _c('md-button', {
    class: _vm.candidat === 'abstentions' ? 'md-raised' : '',
    nativeOn: {
      "click": function($event) {
        _vm.selectCandidat('abstentions')
      }
    }
  }, [_c('div', {
    staticClass: "legend-color",
    staticStyle: {
      "background-color": "#9E9E9E"
    }
  }), _vm._v("Abstentions (25,3%)")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(!_vm.candidat || _vm.candidat === 'blancsnuls') ? _c('md-button', {
    class: _vm.candidat === 'blancsnuls' ? 'md-raised' : '',
    nativeOn: {
      "click": function($event) {
        _vm.selectCandidat('blancsnuls')
      }
    }
  }, [_c('div', {
    staticClass: "legend-color",
    staticStyle: {
      "background-color": "#9E9E9E"
    }
  }), _vm._v("Blancs et nuls (8,8%)")]) : _vm._e()], 1)]), _vm._v(" "), (!_vm.candidat) ? _c('span', [_c('md-subheader', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_vm._v("Votes exprimés (75,78%) :")])], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, _vm._l((_vm.candidatsArray), function(c) {
    return (!_vm.candidat || _vm.candidat === c.id) ? _c('li', [_c('md-button', {
      class: _vm.candidat === c.id ? 'md-raised' : '',
      nativeOn: {
        "click": function($event) {
          _vm.selectCandidat(c.id)
        }
      }
    }, [_c('div', {
      staticClass: "legend-color",
      style: ('background-color:' + c.color)
    }), _vm._v(_vm._s(c.lib) + " (" + _vm._s(c.score.toLocaleString()) + "%)")])], 1) : _vm._e()
  })), _vm._v(" "), (_vm.candidat && _vm.stops[_vm.level]) ? _c('md-layout', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "md-row": ""
    }
  }, [_c('div', {
    staticClass: "gradient",
    style: (("background: linear-gradient(to bottom, " + (_vm.stops[_vm.level].map(function (s) { return s[1]; }).join(',')) + ")"))
  }), _vm._v(" "), _c('ul', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, _vm._l((_vm.stops[_vm.level]), function(stop) {
    return _c('li', [_vm._v(_vm._s(stop[0].toLocaleString()))])
  }))]) : _vm._e()], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('md-sidenav', {
    ref: "detailsSidenav",
    staticClass: "md-right md-fixed"
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.currentDetails.nom))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('p', [_vm._v(_vm._s((_vm.currentDetails['presidentielle2017tour2.inscrits'] || '').toLocaleString()) + " inscrits")]), _vm._v(" "), _c('p', {
    style: ('font-weight:' + (_vm.candidat === 'abstentions' ? 'bold' : 'normal'))
  }, [_vm._v(_vm._s((_vm.currentDetails['presidentielle2017tour2.pourcentageabstentions'] || '').toLocaleString()) + "% d'abstentions")]), _vm._v(" "), _c('p', {
    style: ('font-weight:' + (_vm.candidat === 'blancsnuls' ? 'bold' : 'normal'))
  }, [_vm._v(_vm._s((_vm.currentDetails['presidentielle2017tour2.pourcentageblancsnulsinscrits'] || '').toLocaleString()) + "% de blancs et nuls")]), _vm._v(" "), _c('p', [_vm._v(_vm._s((_vm.currentDetails['presidentielle2017tour2.pourcentageexprimesinscrits'] || '').toLocaleString()) + "% de votes exprimés répartis ainsi :")]), _vm._v(" "), _vm._l((_vm.currentDetails.candidats), function(c) {
    return _c('p', {
      style: ('padding-left:10px;font-weight:' + (c.id === _vm.candidat ? 'bold' : 'normal'))
    }, [_vm._v(_vm._s(c.lib) + " (" + _vm._s(c.scoreLocal.toLocaleString()) + "%)")])
  })], 2), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button close-sidenav",
    nativeOn: {
      "click": function($event) {
        _vm.$refs['detailsSidenav'].close()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e55df00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 68
// module chunks = 0